import { useIntl } from '@capsicum/common';
import { useCallback, useState } from 'react';

export const useThirdPartyTopUpInfoModal = () => {
	const { $t } = useIntl();

	const getTexts = ({
		bold,
		br,
		onramperlink,
		socioslink
	}: {
		bold?: (chunks: Array<React.ReactNode>) => JSX.Element;
		br?: JSX.Element;
		onramperlink?: (chunks: Array<React.ReactNode>) => JSX.Element;
		socioslink?: (chunks: Array<React.ReactNode>) => JSX.Element;
	}) => {
		return {
			checkboxLabel: $t('topup.thirdPartyTopUp.infoModal.checkboxLabel'),
			description: bold
				? $t<JSX.Element>('topup.thirdPartyTopUp.infoModal.description', {
						bold
					})
				: '',
			gotItButton: $t('topup.thirdPartyTopUp.infoModal.gotItButton'),
			terms:
				socioslink && onramperlink && br
					? $t<JSX.Element>('topup.thirdPartyTopUp.infoModal.terms', { br, onramperlink, socioslink })
					: '',
			title: $t('topup.thirdPartyTopUp.infoModal.title'),
			warning:
				br && bold
					? $t<JSX.Element>('topup.thirdPartyTopUp.infoModal.warning', {
							bold,
							br
						})
					: ''
		};
	};

	const termsLinks = {
		sociosTcLink: $t('topup.thirdPartyTopUp.infoModal.sociosTcLink'),
		thirdPartyTcLink: $t('topup.thirdPartyTopUp.infoModal.thirdPartyTcLink')
	};

	const [checked, setChecked] = useState(false);

	const handleCheck = useCallback((onChecked?: (value: boolean) => void) => {
		setChecked(prevChecked => {
			const newChecked = !prevChecked;

			onChecked?.(newChecked);

			return newChecked;
		});
	}, []);

	return { checked, getTexts, handleCheck, termsLinks };
};
